module.exports = __webpack_public_path__ + "static/media/LibreBaskerville-Italic.d32e21a1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LibreBaskerville-Italic.ttf
// module id = 3021
// module chunks = 51